import * as React from "react";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";

export enum ToolTipPosition {
    Right= "right",
    Left= "left",
    Top = "top",
    Bottom = "bottom"
}

export type ToolTipContent = string | (() => JSX.Element) | (() => string) | JSX.Element;

interface ToolTipProps {
    content: ToolTipContent;
    children?: React.ReactNode;
    position?: ToolTipPosition;
    open?: boolean;
    trigger?: "mouseenter" | "focus" | "click" | "manual";
}

const ToolTip: React.StatelessComponent<ToolTipProps> = (props: ToolTipProps) => {
    let content = props.content;
    if (typeof content === "function") {
        content = content();
    }

    const position = props.position ? props.position : ToolTipPosition.Top;

    return <Tooltip open={props.open} trigger={props.trigger} arrow={true} position={position} html={<span>{content}</span>}>
        {props.children}
    </Tooltip>;
};

export default ToolTip;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/ToolTip/ToolTip.tsx